import apiTrainingGroups from '@/api/training-groups'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getTrainingGroupsStart: '[training groups] Get training groups start',
  getTrainingGroupsSuccess: '[training groups] Get training groups success',
  getTrainingGroupsFailure: '[training groups] Get training groups failure',

  getTrainingGroupsSchoolIdStart:
    '[training groups] Get training groups schoolId start',
  getTrainingGroupsSchoolIdSuccess:
    '[training groups] Get training groups schoolId success',
  getTrainingGroupsSchoolIdFailure:
    '[training groups] Get training groups schoolId failure',

  getTrainingGroupsSchoolIdAndAthleteIdStart:
    '[training groups] Get training groups schoolId and athleteId start',
  getTrainingGroupsSchoolIdAndAthleteIdSuccess:
    '[training groups] Get training groups schoolId and athleteId success',
  getTrainingGroupsSchoolIdAndAthleteIdFailure:
    '[training groups] Get training groups schoolId and athleteId failure',

  getTrainingGroupsSchoolIdAndTrainerIdStart:
    '[training groups] Get training groups schoolId and trainerId start',
  getTrainingGroupsSchoolIdAndTrainerIdSuccess:
    '[training groups] Get training groups schoolId and trainerId success',
  getTrainingGroupsSchoolIdAndTrainerIdFailure:
    '[training groups] Get training groups schoolId and trainerId failure',
}

export const actionTypes = {
  getTrainingGroups: '[training groups] Get training groups',
  getTrainingGroupsSchoolId: '[training groups] Get training groups schoolId',
  getTrainingGroupsSchoolIdAndAthleteId:
    '[training groups] Get training groups schoolId and athleteId',
  getTrainingGroupsSchoolIdAndTrainerId:
    '[training groups] Get training groups schoolId and trainerId',
}

const mutations = {
  [mutationTypes.getTrainingGroupsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingGroupsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsSchoolIdStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingGroupsSchoolIdSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsSchoolIdFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsSchoolIdAndAthleteIdStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingGroupsSchoolIdAndAthleteIdSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsSchoolIdAndAthleteIdFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsSchoolIdAndTrainerIdStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingGroupsSchoolIdAndTrainerIdSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsSchoolIdAndTrainerIdFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getTrainingGroups](context) {
    context.commit(mutationTypes.getTrainingGroupsStart)
    return new Promise((resolve) => {
      apiTrainingGroups
        .getTrainingGroups()
        .then((response) => {
          context.commit(mutationTypes.getTrainingGroupsSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingGroupsFailure)
        })
    })
  },

  [actionTypes.getTrainingGroupsSchoolId](context, {schoolId, schoolType}) {
    const params = {
      schoolId,
      schoolType,
    }
    context.commit(mutationTypes.getTrainingGroupsSchoolIdStart)
    return new Promise((resolve) => {
      apiTrainingGroups
        .getTrainingGroupsBySchoolId(params)
        .then((response) => {
          context.commit(
            mutationTypes.getTrainingGroupsSchoolIdSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingGroupsSchoolIdFailure)
        })
    })
  },

  [actionTypes.getTrainingGroupsSchoolIdAndTrainerId](context, params) {
    context.commit(mutationTypes.getTrainingGroupsSchoolIdAndTrainerIdStart)
    return new Promise((resolve) => {
      apiTrainingGroups
        .getTrainingGroupsBySchoolIdAndTrainerId(params)
        .then((response) => {
          context.commit(
            mutationTypes.getTrainingGroupsSchoolIdAndTrainerIdSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(
            mutationTypes.getTrainingGroupsSchoolIdAndTrainerIdFailure
          )
        })
    })
  },

  [actionTypes.getTrainingGroupsSchoolIdAndAthleteId](
    context,
    {schoolId, athleteId}
  ) {
    context.commit(mutationTypes.getTrainingGroupsSchoolIdAndAthleteIdStart)
    return new Promise((resolve) => {
      apiTrainingGroups
        .getTrainingGroupsBySchoolIdAndAthleteId(schoolId, athleteId)
        .then((response) => {
          context.commit(
            mutationTypes.getTrainingGroupsSchoolIdAndAthleteIdSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(
            mutationTypes.getTrainingGroupsSchoolIdAndAthleteIdFailure
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
